module.exports = __webpack_public_path__ + "img/cover_bg.a2453866.png";